"use client";

import useEmblaCarousel, {} from "embla-carousel-react";
import type { ComponentProps } from "react";
import { IconButton } from "~components/ui/icon-button";
import { cn } from "~utils";
import { useCarouselButtons } from "./use-carousel-buttons";

export function Carousel({ children, className }: ComponentProps<"div">) {
  const [emblaRef, emblaApi] = useEmblaCarousel({
    align: "start",
    containScroll: "trimSnaps",
  });

  const hasOverflow = emblaApi && emblaApi.scrollSnapList().length > 1;

  const {
    prevBtnDisabled,
    nextBtnDisabled,
    onPrevButtonClick,
    onNextButtonClick,
  } = useCarouselButtons(emblaApi);

  return (
    <div className="section-item-full flex select-none flex-col gap-xs overflow-hidden px-[var(--section-offset-x)] [&_*]:select-none">
      {hasOverflow && (
        <div className="flex gap-sm">
          <IconButton
            variant="secondary"
            name="ArrowLeft"
            disabled={prevBtnDisabled}
            onClick={onPrevButtonClick}
          />
          <IconButton
            variant="secondary"
            name="ArrowRight"
            disabled={nextBtnDisabled}
            onClick={onNextButtonClick}
          />
        </div>
      )}

      <div
        className="w-full"
        ref={emblaRef}
        style={{ scrollPaddingInline: "var(--section-offset-x)" }}
      >
        <div
          className={cn("grid auto-cols-max grid-flow-col gap-sm", className)}
        >
          {children}
        </div>
      </div>
    </div>
  );
}
